import { useQuery } from '@tanstack/react-query';
import type { AgentApiProfitsShow } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

type Params = {
  id: number;
};

export default function useFetchProfit({ id }: Params) {
  return useQuery({
    queryKey: ['Profit', id],
    queryFn: async () => {
      const data = await fetchJson<AgentApiProfitsShow>(`/agent/api/profits/${id}.json`);
      return data;
    },
  });
}
